import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
// import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import EnterpriseNewUnitRepository from '@/shared/http/repositories/realestate/enterprisenewunit'
import Multiselect from 'vue-multiselect'
import { toast, loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'searchocurrence',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ,
    Multiselect
  },
  data () {
    return {
      title: 'Lista de Chamados',
      dataspersonalizadas: false,
      problemaRaiz: [],
      patologias: [],
      dataempreendimento: [],
      statusocorrencia: [],
      patologiaArray: [],
      patologiaInternoArray: [],
      empreendimentoInternoArray: [],
      statusInternoArray: [],
      SituacaoInternoArray: [],
      empreendimentoArray: [],
      TecnicoIdData: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      SearchItems: {},
      formSearch: {
        patologia: [],
        empreendimentoId: [],
        periodoEnum: 0,
        filtroPersonalizado: false,
        DataInicio: null,
        DataFinal: null,
        statusOcorrencia: []
      },
      Nome: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      types: [
      ],
      selectedPatologia: null,
      contapatologia: null
    }
  },
  watch: {
    patologiaInternoArray () {
      this.formSearch.patologia = this.patologiaInternoArray.map(x => x.value)
    },
    empreendimentoInternoArray () {
      this.formSearch.empreendimentoId = this.empreendimentoInternoArray.map(x => x.id)
    },
    statusInternoArray () {
      this.formSearch.statusOcorrencia = this.statusInternoArray.map(x => x.value)
    }
  },
  mounted () {
    this.getEmpreendimento()
    this.GetStatusRelatorioInsumos()
    this.GetPatologia()
  },
  methods: {
    GetStatusRelatorioInsumos () {
      OcurrenceRepository.GetStatusRelatorioInsumos()
        .then(Response => {
          loading.pop()
          this.statusocorrencia = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    Search () {
      this.contapatologia = this.patologiaInternoArray.length
      if (this.patologiaInternoArray.length === 0) {
        this.contapatologia = this.patologiaArray.length
      }
      if (this.contapatologia < 10) {
        this.contapatologia = '0' + this.contapatologia
      }
      this.$emit('contapatologia', this.contapatologia)
      localStoreHelper.controleOcorrencia.contapatologia(this.contapatologia)
      if (this.formSearch.periodoEnum === 3 && (this.formSearch.dataFinal == null || this.formSearch.dataInicio == null)) {
        toast.error('Insira as datas do período')
      } else {
        loading.push()
        let aux = {...this.formSearch}
        localStoreHelper.controleOcorrencia.relatorio(aux)
        this.$emit('search', aux)
        loading.pop()
      }
    },
    Clear () {
      // this.$refs.searchReports.clear()
      // Object.keys(this.formSearch).forEach((Element) => {
      //   this.formSearch[Element] = null
      // })
      localStoreHelper.controleOcorrencia.relatorio(null)
      this.patologiaInternoArray = []
      this.formSearch.patologia = []
      this.empreendimentoInternoArray = []
      this.formSearch.empreendimentoId = []
      this.statusInternoArray = []
      this.formSearch.statusOcorrencia = []
      this.formSearch.dataFinal = null
      this.formSearch.dataInicio = null
      this.formSearch.periodoEnum = 0
      let input = document.querySelector('.btn-periodos-active')
      if (input != null) {
        input.classList.remove('btn-periodos-active')
        input.classList.add('btn-periodos')
      }
    },
    GetPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then(Response => {
          this.patologiaArray = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getEmpreendimento () {
      EnterpriseNewUnitRepository.GetEmpreendimentoNovaUnidadeByInsumos()
        .then((Response) => {
          this.empreendimentoArray = Response.data
        })
    },
    opcoes () {
      this.dataspersonalizadas = !this.dataspersonalizadas
      if (this.dataspersonalizadas) {
        this.formSearch.periodoEnum = 3
      }
    },

    filter (obj) {
      this.typeSearch = obj.target.id
      if (obj.target.id === 'semanal') {
        this.dataspersonalizadas = false
        const now = new Date()
        this.formSearch.periodoEnum = 1

        var diferencaPSegunda = now.getDay() - 1
        var diferencaPSexta = (5 - now.getDay())

        const monday = new Date()
        monday.setDate(now.getDate() - diferencaPSegunda)

        const friday = new Date()
        friday.setDate(now.getDate() + diferencaPSexta)

        this.formSearch.dataInicio = monday
        this.formSearch.dataFinal = friday
      }

      if (obj.target.id === 'mensal') {
        this.dataspersonalizadas = false
        const now = new Date()
        this.formSearch.periodoEnum = 0

        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)

        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

        this.formSearch.dataFinal = lastDay
        this.formSearch.dataInicio = firstDay
      }

      if (obj.target.id === 'anual') {
        this.dataspersonalizadas = false
        const now = new Date()
        this.formSearch.periodoEnum = 2

        const firstDay = new Date(now.getFullYear(), 0, 1)

        const lastDay = new Date(now.getFullYear(), 11, 31)

        this.formSearch.dataFinal = lastDay
        this.formSearch.dataInicio = firstDay
      }

      if (obj.target.id === 'personalizado') {
        this.dataspersonalizadas = true
        this.formSearch.periodoEnum = 3
      }
      let id = obj.target.id
      document.querySelectorAll('.btn-periodos-active').forEach((element) => {
        element.classList.remove('btn-periodos-active')
        element.classList.add('btn-periodos')
      })
      document.getElementById(id).classList.toggle('btn-periodos')
      document.getElementById(id).classList.toggle('btn-periodos-active')
    },

    addTag (newTag) {
      const tag = {
        text: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/reports/components/searchReports/searchReports.js